import { useState } from 'react';
import ComboBox from '../../components/controls/ComboBox/ComboBox';
import FindRecord from '../../components/controls/FindRecord/FindRecord';
import TextBox from '../../components/controls/TextBox/TextBox';
import { AccountCacheService } from '../../services/accountService';
import FormCommand from '../../components/controls/FormCommand/FormCommand';
import { IRole } from '../../models/interfaces';
import roleService from '../../services/roleService';
import GridView from '../../components/controls/GridView/GridView';

export interface ConfigureApprovalProps<T> {
}

function ConfigureApproval<T>(props: ConfigureApprovalProps<T>) {
	const [transactionTypeCode, setTransactionTypeCode] = useState("");
	const [selectedRole, setSelectedRole] = useState<IRole>();
	const accountCacheService = new AccountCacheService();
	return (
		<div className='row'>
			<div className="col-7">
				<h3>Configure Approval Channel</h3>
				<hr />

				<FindRecord<IRole> id='findRole' text='Select Role'
					getRecords={() => {
						return roleService.getRoles({});
					}}
					onSelectRecord={(role) => {
						if (role) {
							setSelectedRole(role);
							return `${role?.name}`;
						}
						return "";
					}}
					hideColumns={["id", "businessId", "permissions", "transactionTypes",
						"transactionLimitType"]} />

				<div className="row">
					<div className="col">
						<ComboBox id='approvalLevel' text='Select Approval Level'
							prompt='Select Approval Level'
							items={[
								{ id: "1", name: "Level 1" },
								{ id: "2", name: "Level 2" },
								{ id: "3", name: "Level 3" },
								{ id: "4", name: "Level 4" },
								{ id: "5", name: "Level 5" },
								{ id: "6", name: "Level 6" }
							]} />

					</div>
					<div className="col">
						<ComboBox id='transactionType' text='Select Transaction Type'
							prompt='Select Transaction Type'
							value={transactionTypeCode}
							items={accountCacheService.getTransationTypes().map(d => {
								return { id: d.id, name: d.name }
							})}
							onChange={(e) => {
								setTransactionTypeCode(e.currentTarget.value);
							}} />
					</div>
				</div>

				<div className="row">
					<div className="col">
						<TextBox type='number' id='minAmount' placeHolder='Minumum Amount' text='Amount' />
					</div>
					<div className="col">
						<TextBox type='number' id='maxAmount' placeHolder='Maximum Amount' text='Amount' />
					</div>
				</div>

				<FormCommand />

				<div className="section section-primary">
					<GridView name='lstRoleApprovalSetup'
						columnHeaders={[
							<th>Role</th>,
							<th>Approval Level</th>,
							<th>Transaction Type</th>,
							<th>Min Amount</th>,
							<th>Max Amount</th>,
						]}
					/>

				</div>
			</div>
			<div className="col-5"></div>
		</div>
	);
}

export default ConfigureApproval;